<template>
  <div class="accordion" :class="{current : isOpen}">
    <div class="accordion-header" @click="toggle">
      <div class="">
        <slot name="header"></slot>
      </div>

      <button class="no-btn" type="button" name="button" data-test="btnAccordion">
        <IconChevronDown class="accordion-chevron" :class="{'spin': !isOpen}"/>
      </button>
    </div>

    <div class="accordion-content">
      <slot name="content"></slot>
    </div>
  </div>
</template>

<style lang="scss" scoped>
.accordion {
  @include                        border_radius(10px);
  color:                          var(--Shades-90);
  text-align:                     left;
  width:                          100%;
  max-height:                     48px;
  // padding:                        14px 20px;
  // background-color:               var(--Shades-W);
  // border:                         1.5px solid var(--Shades-30-Border);
  outline:                        none;

  &.current,
  table {
    overflow:                     hidden;
  }

  .accordion-header {
    display:                      flex;
    align-items:                  center;
    justify-content:              space-between;
    gap:                          10px;
    line-height:                  normal;
    padding:                      10px 0;
    cursor:                       pointer;

    > div {
      display:                    flex;
      flex-direction:             row;
      gap:                        10px;
    }

    .no-btn {
      display:                    flex;
      align-items:                center;
      flex-shrink:                0;
      margin:                     0;
      padding:                    0;
    }

    .accordion-chevron {
      @include                    transition(.4s);
      display:                    inline-block;

      &.spin {
        @include                  rotate(-180deg);
      }
    }

    :slotted(h4) {
      color:                      var(--Shades-90);
      font-size:                  var(--font-size-16);
      font-weight:                500;
      line-height:                normal;
      text-overflow:              ellipsis;
      overflow:                   hidden;
      margin:                     0;
    }
  }

  .accordion-content {
    display:                      none;
    padding-bottom:               15px;
    opacity:                      0;
  }

  hr {
    margin-top:                   5px;
    margin-bottom:                5px;
  }

  &.current {
    @include                      transition(max-height .4s ease-in);
    max-height:                   100%;

    .accordion-content {
      @include                    transition(opacity .4s);
      display:                    block;
      margin-top:                 15px;
      opacity:                    1;
    }
  }
}
</style>

<script>
export default {
  name: 'BaseAccordion',
  props: {
    open: { type: Boolean, default: false }
  },
  emits: ['update:open'],
  data() {
    return {
      isOpen: !!this.open
    }
  },
  watch: {
    open(newValue) {
      this.isOpen = newValue
    }
  },
  methods: {
    toggle() {
      this.isOpen = !this.isOpen
      this.$emit('update:open', this.isOpen)
    }
  },
}
</script>
